import { render } from "./PageHeroTpl.vue?vue&type=template&id=43338a19&scoped=true"
import script from "./PageHeroTpl.vue?vue&type=script&lang=js"
export * from "./PageHeroTpl.vue?vue&type=script&lang=js"

import "./PageHeroTpl.vue?vue&type=style&index=0&id=43338a19&scoped=true&lang=css"

import exportComponent from "/Users/medvedevpavel/Documents/code/lb_advice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43338a19"]])

export default __exports__